<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { cn } from '../ui-utils.ts';

const props = defineProps<{
  class?: HTMLAttributes['class'];
  disableWrappingDivClass?: boolean;
}>();
</script>

<template>
  <div :class="disableWrappingDivClass ? '' : 'relative w-full overflow-auto'">
    <table :class="cn('w-full caption-bottom text-sm', props.class)">
      <slot />
    </table>
  </div>
</template>
